import axios from "axios";

import { systemURL, fechaISO, imageURL } from "@/constants";

export default {
    name: "sistema",
    components: {},
    data() {
        return {
            systemId: "",
            local: "",
            descripcion: "",
            razonSocial: "",
            direccion: "",
            numeroSerie: "",
            instalacion: "",
            notas: "",
            fecha: "",
            vencimiento: "",
            notasUltimoMantenimiento: "",
            imagenes: []
        };
    },

    computed: {
        soloAlta() {
            return !this.$route.params.systemId;
        },

        loggedIn() {
            return localStorage.loggedIn;
        }
    },

    async mounted() {
        const systemId = this.$route.params.systemId;
        if (this.soloAlta) {
            this.instalacion = fechaISO();
        } else {
            try {
                const promise1 = axios.get(systemURL(localStorage.userToken, systemId));
                const datos1 = await promise1;
                const result1 = datos1.data[0] || {};

                this.systemId = result1.system_id;
                this.local = result1.fantasy_name;
                this.descripcion = result1.system_description;
                this.razonSocial = result1.company_name;
                this.direccion = result1.address;
                this.numeroSerie = result1.serial_number;
                this.instalacion = result1.installation_date;
                this.notas = result1.notes;
                this.fecha = result1.last_system_maintenance.maintenance_date;
                this.vencimiento = result1.last_system_maintenance.maintenance_valid_until;
                this.notasUltimoMantenimiento = result1.last_system_maintenance.notes;
                this.imagenes = result1.files.map(r => ({ id: r.system_file_id, url: imageURL(r.system_file_id) }));
            } catch (e) {
                window.console.log("ERROR!!");
            }
        }
    },

    methods: {
        abrirImagen(s) {
            window.console.log("ABRIR", s);
            // window.open(s, "_blank");
            this.$router.push("/imagen/" + s);
        },

        verEventosClick() {
            this.$router.push("/detalle/" + this.systemId);
        },

        agregarMantenimientoClick() {
            this.$router.push("/mantenimiento/" + this.systemId);
        },

        generarQrClick() {
            window.alert("Procedimiento para generar QR - no habilitado aún");
        },

        borrarClick() {
            window.alert("Procedimiento para borrar sistema - no habilitado aún");
        },

        crearClick() {
            window.alert("Procedimiento para agregar sistema - no habilitado aún");
            this.$router.go(-1);
        },

        volverClick() {
            this.$router.go(-1);
        }
    }
};
